/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';

import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Spinner from '@zg-rentals/multibrand-ui/lib/Spinner';

import queryUtils from '../../../utils/queryUtils';

class NativeAppSignInPage extends React.Component {
  // call native app sign in
  componentDidMount() {
    const { queryString } = this.props,
      params = queryUtils.parse(queryString),
      unescapedPath = unescape(params.url),
      baseUrl = window.location.origin,
      redirectUrl = baseUrl + unescapedPath;

    if (window.ZMOB_nativeAPI && window.ZMOB_nativeAPI.reauthForRenterHub) {
      window.ZMOB_nativeAPI.reauthForRenterHub('ZAuthRegistrationReasonRenterHub', 'renter-hub-apply-now', redirectUrl);
    }
  }

  render() {
    return (
      <Center>
        <SpacerRow size="lg">
          <Spinner />
        </SpacerRow>
      </Center>
    );
  }
}

const mapStateToProps = (state) => ({
  queryString: state.router.location.search,
});

export default connect(mapStateToProps)(NativeAppSignInPage);
